// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__4GpvT","colMin":"styles_colMin__2Y9XZ","colCheckbox":"styles_colCheckbox__3dJAI"};